"use client"
import React, { useState, useEffect } from "react";
import { useContext } from "react";
// import { Link } from "react-router-dom";
import Link from 'next/link';
import { AppContext } from "../context/AppContext";
import { ActivateCoupon, CancelCoupon } from "../services/coupon";
import { OpenCashier } from "../services/cashier";
import { GetUserInfo } from "../services/user";

const PopupCoupons = ({ isOpen, onClose }) => {
  const {
    isCouponActivated,
    setPageLoader,
    setActiveCoupon,
    activeCoupon,
    setIsCouponActivated,
    isMobile,
    setLink, 
    setOpenModal,
    setIsClosed,
    setUser,
    setIsCouponOpen
  } = useContext(AppContext);
  const [animationClass, setAnimationClass] = useState("");
  const [cuponCode, setCuponCode] = useState('');

  useEffect(() => {
    setAnimationClass("ShowAni");
  }, []);

  const [errorCouponMessage, setErrorCouponMessage] = useState(null);
  const [isRedeemed, setIsRedeemed] = useState(false);
  const activateCoupon = (event) => {
    event.preventDefault();
    setErrorCouponMessage(null);
    setPageLoader(true);
    ActivateCoupon({ cuponCode: cuponCode.toUpperCase() })
    .then((response) => {
      if(response !== 204) {
        setActiveCoupon(response[0]);
        setIsCouponActivated(response[0]?.bank_method_list ? false : true);
        setIsRedeemed(true);
        GetUserInfo()
        .then(setUser)
        .catch(() => {});
      }
    })
    .catch((error) => {
      setErrorCouponMessage(error?.response?.data?.message);
    })
    .finally(() => setPageLoader(false))
  }

  const openCashier = (isDeposit = true) => {
    setPageLoader(true);
    OpenCashier({ isMobile, isDeposit })
    .then(response => {
      setLink(response);
      isMobile && Tawk_API.hideWidget();
      setOpenModal(true);
      setIsClosed(true);
      setIsCouponOpen(false);
    })
    .catch(() => {})
    .finally(() => setPageLoader(false));
  };

  const openModal = () => {
    document.getElementById('id01').style.display='block';
  }

  const closeModal = () => {
    document.getElementById('id01').style.display='none';
  }

  const cancelCoupon = (event) => {
    event.preventDefault();
    setPageLoader(true);
    CancelCoupon({ couponCode: activeCoupon?.coupon_code })
    .then((response) => {
      setActiveCoupon(null);
      setIsCouponActivated(false);
      closeModal();
    })
    .catch((error) => {
    })
    .finally(() => setPageLoader(false))
  }

  if (!isOpen) return null;
  return (
    <div className={`SectionCoupons ${animationClass}`}>
       {isRedeemed && (
          <div
            style={{ marginBottom: 20 }}
            className="success SuccessBlink"
          >
            You have successfully redeemed the coupon
          </div>
        )}
      <button onClick={onClose} className="BtnClosePopup"></button>
      <h1 id="CouTitle">Coupons</h1>
      <div id="id01" className="modal">
        <form className="modal-content">
          <div className="container">
            <h1>Cancel Coupon</h1>
            <p>Are you sure you want to cancel coupon ?</p>
            <div className="CouponCode CodeBlink">{activeCoupon?.coupon_code ?? '*****'}</div>

            <div className="RowContBntsCCP">
              <div className="Btns BtnDeposit" onClick={closeModal}>
                No
              </div>
              <div className="Btns BtnCancel" onClick={cancelCoupon}>
                Yes
              </div>
            </div>
          </div>
        </form>
      </div>

      {!activeCoupon && (
        <div className="ContendPoCoupons">
          <form className="RowBarCoupons" onSubmit={activateCoupon}>
            <p>Enter a Coupon Code:</p>
            <input
              type="text"
              placeholder="Coupon Code"
              className="InputText"
              onChange={(event) => setCuponCode(event.target.value)}
              value={cuponCode}
              required
            />
            <button className="UserBtns">REDEEM COUPON</button>
          </form>
          {errorCouponMessage && (
            <div style={{ margin: 10 }} className="error ErrorBlink">
              {errorCouponMessage}
            </div>
          )}
        </div>
      )}

      {activeCoupon && (
        <div className="ContendPoCoupons">
          <div className="CouponCode CodeBlink">
            {activeCoupon?.coupon_code ?? '*****'}
          </div>
          <p>
            <Link href={'/terms'} onClick={() => setIsCouponOpen(false)}>Terms and Conditions</Link>
          </p>
          {!activeCoupon?.bank_method_list?.length ? (
            <p>
              Coupon{" "}
              <strong className="CodeBlink">{activeCoupon?.coupon_code ?? '*****'}</strong>{" "}
              was redeemed for ${activeCoupon?.coupon_amount} Congratulations!
            </p>
          ) : (
            <p>
              Coupon{" "}
              <strong className="CodeBlink">
                {activeCoupon?.coupon_code ?? '*****'}{" "}
              </strong>
              will be active on your next deposit
            </p>
          )}

          {!isCouponActivated && (
            <div className="RowContBntsCCP">
              <div className="Btns BtnCancel" onClick={openModal}>
                Cancel Coupon
              </div>
              <div className="Btns BtnDeposit" onClick={() => openCashier()}>
                Make Deposit
              </div>
            </div>
          )}

          {activeCoupon?.bank_method_list?.length && (
            <table>
              <thead>
                <tr>
                  <th>Deposit Method</th>
                  <th>Minimum Deposit</th>
                  <th>Maximum Deposit</th>
                  <th>Bonus</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td>{activeCoupon?.bank_method_list[0]?.deposit_method}</td>
                  <td>${activeCoupon?.bank_method_list[0]?.minimum_deposit}</td>
                  <td>
                    {activeCoupon?.bank_method_list[0]?.maximum_deposit ??
                      "Unlimited"}
                  </td>
                  <td>{activeCoupon?.bank_method_list[0]?.bonus}%</td>
                </tr>
              </tbody>
            </table>
          )}
          {activeCoupon?.free_spin_details?.free_spin ? (
            <p>
              {activeCoupon?.spins_needed} Free spins valid for:{" "}
              {activeCoupon?.free_spin_details?.game_description} (
              {activeCoupon?.free_spin_details?.num_lines} lines at{" "}
              {activeCoupon?.free_spin_details?.denomination})
            </p>
          ) : (
            <>
              <p>
                Max Coupon Amount: $
                {activeCoupon?.message_flags?.max_coupon_amount}
              </p>
              <p>BONUS TYPE: {activeCoupon?.message_flags?.bonus_type}.</p>
            </>
          )}

          <div className="CouponSubTitle">Playthrough details</div>
          <p>Played: ${activeCoupon?.playthrough_details?.amount_played}</p>
          <p>Needed: ${activeCoupon?.playthrough_details?.amount_needed}</p>
          <p>
            Maximum Withdrawable Amount: $
            {activeCoupon?.playthrough_details?.real_money_withdrawals_limit}
          </p>
          <div className="CouponSubTitle">Excluded games</div>
          <ul>
            {activeCoupon?.game_exclusion_list?.map((game, index) => (
              <li key={index}>
                <p>{game.game_description}</p>
              </li>
            ))}
          </ul>
        </div>
      )}
    </div>
  );
};

export default PopupCoupons;
